"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactComponents = require("@cimpress/react-components");

var _CssLoader = _interopRequireDefault(require("@cimpress/react-components/lib/CssLoader"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var Robot = _reactComponents.shapes.Robot;

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    (0, _classCallCheck2["default"])(this, ErrorBoundary);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      hasError: false,
      error: undefined,
      errorInfo: undefined,
      componentStack: undefined
    });
    return _this;
  }

  (0, _createClass2["default"])(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error, errorInfo) {
      console.error({
        error: error,
        errorInfo: errorInfo
      });
      this.setState(errorInfo, function () {
        return errorInfo;
      });
    }
  }, {
    key: "render",
    value: function render() {
      if (this.state.hasError) {
        var _this$state$component;

        return /*#__PURE__*/_react["default"].createElement(_CssLoader["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            paddingLeft: '25%',
            width: '75%'
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: {
            position: 'fixed',
            left: '50%',
            transform: 'translate(-50%, 0%)'
          }
        }, /*#__PURE__*/_react["default"].createElement(Robot, {
          status: "danger",
          size: "lg"
        })), /*#__PURE__*/_react["default"].createElement("h2", {
          style: {
            position: 'fixed',
            top: '40%',
            left: '50%',
            transform: 'translate(-50%, -40%)',
            fontWeight: 'bold'
          }
        }, "Uh Oh! Something went wrong."), /*#__PURE__*/_react["default"].createElement("details", {
          style: {
            position: 'fixed',
            top: '45%',
            width: '50%',
            whiteSpace: 'pre-wrap',
            color: 'red'
          }
        }, JSON.stringify(this.state.error.name + ' : ' + this.state.error.message), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), JSON.stringify((_this$state$component = this.state.componentStack) === null || _this$state$component === void 0 ? void 0 : _this$state$component.trim().replace(/\n/g, '')))));
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        hasError: error ? true : false,
        error: error
      };
    }
  }]);
  return ErrorBoundary;
}(_react["default"].Component);

var _default = ErrorBoundary;
exports["default"] = _default;